import type { VerbTypes } from 'modules/core/lib/verbTypes'

type VerbOption = Record<string, VerbTypes>
type Options = Record<string, VerbOption>

export const getPermissionVerbs = (): Options => {
  const reviewVerbs: Options = {
    forms: {
      permission: 'apiCore.accessReviewsCreateForms',
      owned: 'reviews.formCreateSelf',
      everybody: 'reviews.formCreateEverybody',
      reportees: 'reviews.formCreateReportees',
      team: 'reviews.formCreateTeam',
    },
    templates: {
      permission: 'apiCore.accessReviewsCreateTemplates',
    },
  }

  return reviewVerbs
}
